import { getFormattedDateFns } from 'shared/helpers/locale';
import { getRange } from 'shared/helpers/arrays';

export const getUserName = ({ first_name: firstName = null, last_name: lastName = null }) =>
  firstName || lastName ? [firstName, lastName].filter(i => !!i).join(' ') : null;

export const getUserThing = ({ email, phones = [], name }) => {
  const verifiedPhones = phones.filter(phone => phone.is_verified);
  const emailAndPhones = verifiedPhones.length > 0 ? `${verifiedPhones[0].number}` : email;
  return name || emailAndPhones;
};

export const formatPhone = phone => {
  const numberPhone = phone.replace(/[+\s_()]/g, '');
  return `380${numberPhone.slice(-9)}`;
};

export const verifyYear = year =>
  year && (year < 1900 || year > +Number(getFormattedDateFns(new Date(), 'yyyy')));

export const getYearsOptions = () => {
  const YEAR_FROM = 1901;
  const YEAR_TO = new Date().getFullYear();
  const YEARS = getRange(YEAR_FROM, YEAR_TO);

  return YEARS.map(year => ({ title: year, val: year })).reverse();
};

export const getParamByKey = (arr, key) => {
  if (arr && arr.length) return arr[0][key];
  return null;
};

export const rewriteMinMaxYear = year => {
  if (!year) return year;
  else if (+year < 1900) return 1900;
  else if (+year > +Number(getFormattedDateFns(new Date(), 'yyyy')))
    return +Number(getFormattedDateFns(new Date(), 'yyyy'));
  return +year;
};

export const correctionYears = formState => {
  let { yearTo, yearFrom } = formState;

  yearTo = rewriteMinMaxYear(yearTo);
  yearFrom = rewriteMinMaxYear(yearFrom);

  if (yearTo && yearFrom && yearTo < yearFrom) return { yearTo: yearFrom, yearFrom: yearTo };
  return { yearTo, yearFrom };
};

/**
 * Get count of activated adverts
 * @returns {Number}
 */
export const getActiveAdvsCount = user => {
  if (!user || !user.id) return 0;
  const activeKeys = Object.keys(user.active_adverts);
  const count = activeKeys.reduce((acc, value) => acc + user.active_adverts[value], 0);
  return count;
};

/**
 * Get count of activated adverts
 * @returns {Boolean}
 */
export const isSlotAvailable = user => {
  if (getActiveAdvsCount(user) === 0) return true;
  return !!user.tariff && user.tariff.slots_limit > getActiveAdvsCount(user);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/users.js